import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";

export default function StickyMobileCTABar({ whatsappUrl, ctaLabel = "Cotizar", onCtaClick, ctaHref, telHref, testId = "sticky-mobile-cta" }) {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 200);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!visible) return null;
    return (
        <div
            data-testid={testId}
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex border-t border-black/20 safe-bottom"
            style={{ animation: "fadeUp 0.3s ease-out" }}
        >
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${testId}-whatsapp`}
                className="flex-1 inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebd5b] text-white py-3.5 font-display font-bold text-sm uppercase tracking-wider transition-colors"
            >
                <MessageCircle className="w-5 h-5" />
                WhatsApp
            </a>
            {ctaHref ? (
                <a
                    href={ctaHref}
                    data-testid={`${testId}-action`}
                    className="flex-1 inline-flex items-center justify-center gap-2 bg-eclipse-cta text-white py-3.5 font-display font-bold text-sm uppercase tracking-wider"
                >
                    <Phone className="w-5 h-5" />
                    {ctaLabel}
                </a>
            ) : (
                <button
                    onClick={onCtaClick}
                    data-testid={`${testId}-action`}
                    className="flex-1 inline-flex items-center justify-center gap-2 bg-eclipse-cta text-white py-3.5 font-display font-bold text-sm uppercase tracking-wider"
                >
                    {telHref ? <Phone className="w-5 h-5" /> : null}
                    {ctaLabel}
                </button>
            )}
        </div>
    );
}
